import { render } from "./PurchaseRequestModal.vue?vue&type=template&id=5effefb3&scoped=true"
import script from "./PurchaseRequestModal.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestModal.vue?vue&type=script&lang=js"

import "./PurchaseRequestModal.vue?vue&type=style&index=0&id=5effefb3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5effefb3"]])

export default __exports__